export default [
  {
    name: 'setting-filters',
    path: '/settings/filters',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Configuração de Filtros',
      icon: 'dvr',
      label: 'Configuração de Filtros',
      roles: ['Admin']
    }
  }
]
